import React from "react";
import { Input } from "@shared/ui/Inputs";
import BodyText from "@shared/ui/BodyText";
import { Eye, EyeSlash } from "phosphor-react";
import { getPasswordInputClasses } from "../utils/validation";

interface PasswordInputProps {
  keyId: string;
  name: string;
  label: string;
  value: string;
  showPassword: boolean;
  errorMessage?: string;
  hint?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onToggleVisibility: () => void;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  keyId,
  name,
  label,
  value,
  showPassword,
  errorMessage,
  hint,
  onChange,
  onToggleVisibility,
}) => {
  const inputClasses = getPasswordInputClasses(!!errorMessage, !!value);

  return (
    <div className="mb-lg">
      <Input
        keyId={keyId}
        name={name}
        label={label}
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={onChange}
        trailingIconConfig={{
          icon: showPassword ? <Eye /> : <EyeSlash />,
          onClick: onToggleVisibility,
        }}
        errorMessage={errorMessage}
        customInputClasses={inputClasses}
        wrapperClasses="mb-sm"
      />
      {hint && <BodyText color="text-secondary">{hint}</BodyText>}
    </div>
  );
};
